var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "image-item", class: _vm.imageClasses },
    [
      _c("div", { staticClass: "image-thumb" }, [
        _c("img", {
          directives: [
            {
              name: "b-tooltip",
              rawName: "v-b-tooltip.hover",
              modifiers: { hover: true }
            }
          ],
          attrs: {
            title: _vm.imageAltText,
            src:
              _vm.apiUrl +
              "viewFileSocialMediaPost/" +
              _vm.image.social_post_id +
              "/" +
              _vm.image.id +
              "/" +
              _vm.token
          },
          on: {
            click: _vm.thumbnailClicked,
            mousedown: _vm.thumbnailMouseDown,
            mouseup: _vm.thumbnailMouseUp
          }
        })
      ]),
      _vm._v(" "),
      !_vm.disabled
        ? _c(
            "a",
            {
              staticClass: "image-delete",
              attrs: { href: "#", "data-img-id": _vm.image.id },
              on: { click: _vm.deleteImageClicked }
            },
            [_c("i", { staticClass: "fas fa-trash" })]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: { id: "image-thumbnail-popup-modal", size: "lg" },
          scopedSlots: _vm._u([
            {
              key: "modal-footer",
              fn: function(ref) {
                var ok = ref.ok
                var cancel = ref.cancel
                var hide = ref.hide
                return [
                  _c("div", { staticClass: "image-alt" }, [
                    _c(
                      "label",
                      { attrs: { for: "image-alt-" + _vm.image.id } },
                      [_vm._v("Image Alt Text")]
                    ),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.alt,
                          expression: "alt"
                        }
                      ],
                      ref: "altTextInput",
                      staticClass: "image-alt-input",
                      class: _vm.imageClasses,
                      attrs: {
                        name: "image-alt-" + _vm.image.id,
                        type: "text",
                        placeholder: "Enter image alt text",
                        disabled: _vm.altDisabled
                      },
                      domProps: { value: _vm.alt },
                      on: {
                        blur: _vm.imageAltTextUpdated,
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.alt = $event.target.value
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn delete-deliverable-btn",
                        attrs: { title: "Delete Image" },
                        on: { click: _vm.deleteImageClicked }
                      },
                      [_c("i", { staticClass: "fas fa-trash-alt" })]
                    )
                  ])
                ]
              }
            }
          ]),
          model: {
            value: _vm.showImagePopup,
            callback: function($$v) {
              _vm.showImagePopup = $$v
            },
            expression: "showImagePopup"
          }
        },
        [
          _c("img", {
            staticClass: "post-image-popup",
            attrs: {
              src:
                _vm.apiUrl +
                "viewFileSocialMediaPost/" +
                _vm.image.social_post_id +
                "/" +
                _vm.image.id +
                "/" +
                _vm.token
            }
          })
        ]
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            type: "warn",
            title: "Confirm Deletion",
            "ok-title": "Yes, Delete"
          },
          on: { ok: _vm.onConfirmRemoveImage },
          model: {
            value: _vm.showRemoveImage,
            callback: function($$v) {
              _vm.showRemoveImage = $$v
            },
            expression: "showRemoveImage"
          }
        },
        [_c("p", [_vm._v("Are you sure you want to delete this image?")])]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }